import { useCallback } from 'react';
import { authService } from '../services/authService';

export const useAuth = () => {
    /**
     * Connexion
     */
    const login = useCallback(async (email, password) => {
        try {
            const user = await authService.login(email, password);

            return user;
        } catch (error) {
            console.error('useAuth.login erreur:', error);
            throw error;
        }
    }, []);

    /**
     * Inscription (client)
     */
    const register = useCallback(async (userData) => {
        try {
            const user = await authService.register(userData);

            return user;
        } catch (error) {
            console.error('useAuth.register erreur:', error);
            throw error;
        }
    }, []);

    /**
     * Déconnexion
     */
    const logout = useCallback(async () => {
        try {
            await authService.logout();

        } catch (error) {
            console.error('useAuth.logout erreur:', error);
            throw error;
        }
    }, []);

    return {
        login,
        register,
        logout,
    };
};
